export function AlphaViz() {
  return (
    <div className="relative h-33 overflow-hidden rounded-md border border-purple-default/15 bg-purple-01">
      <svg
        viewBox="0 0 320 132"
        className="absolute inset-0 h-full w-full"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="onb-alpha-fill" x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="0%"
              stopColor="var(--purple-default)"
              stopOpacity="0.18"
            />
            <stop
              offset="100%"
              stopColor="var(--purple-default)"
              stopOpacity="0"
            />
          </linearGradient>
        </defs>
        <path
          d="M0 106 L40 96 L80 104 L120 76 L160 84 L200 50 L240 60 L280 28 L320 22 L320 132 L0 132 Z"
          fill="url(#onb-alpha-fill)"
        />
        <path
          d="M0 106 L40 96 L80 104 L120 76 L160 84 L200 50 L240 60 L280 28 L320 22"
          fill="none"
          stroke="var(--purple-default)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div className="absolute top-m left-l">
        <VizLabel
          label="EQUITY CURVE"
          metric="+42.8%"
          color="text-purple-default"
        />
      </div>
    </div>
  );
}

const CAPITAL_BARS = [62, 88, 44, 96, 70, 100, 58];

export function CapitalViz() {
  return (
    <div className="flex h-33 flex-col overflow-hidden rounded-md border border-green-default/15 bg-green-01 px-l pt-m pb-l">
      <VizLabel
        label="WEEKLY REWARDS"
        metric="+1,284 USDC"
        color="text-green-default"
      />
      <div className="mt-s flex flex-1 items-end gap-s">
        {CAPITAL_BARS.map((height) => (
          <div
            key={height}
            className="flex-1 rounded-t-xs bg-linear-to-t from-green-default/35 to-green-default"
            style={{ height: `${height}%` }}
          />
        ))}
      </div>
    </div>
  );
}

function VizLabel({
  label,
  metric,
  color,
}: {
  label: string;
  metric: string;
  color: string;
}) {
  return (
    <div>
      <p className="text-body-micro font-medium text-gray-2">{label}</p>
      <p className={`mt-xs text-h2 font-bold ${color}`}>{metric}</p>
    </div>
  );
}
